<template>
    <div class="container">
        <el-container class="base-container" :direction="vertical">
            <el-header height="" class="header">
                <el-row>
                    <el-col :span="6" :offset="0" class="left">
                        <div class="img-box">
                            <img :src="require('@/assets/static/5dd35c86f8b2081534885d3f2d8ecde.png')" alt="" class="img">
                        </div>
                        <span class="title">慧租房房态管理</span>
                    </el-col>
                    <!-- <el-col :span="14" :offset="0">
                        1
                    </el-col> -->
                    <el-col class="right" :span="18" :offset="0">
                        <span class="user">{{user.groupName}}</span>
                        <span class="user">{{user.name}}</span>
                        <span class="logout" @click="logout">[退出]</span>
                    </el-col>
                </el-row>
            </el-header>
            <el-container class="custom-container content-container" :direction="horizontal">
                <el-aside width="140px" v-if="aside">
                    <!-- Aside content -->
                    <Aside :item="aside"></Aside>
                </el-aside>
                <el-container :direction="vertical">
                    <el-main height="">
                        <slot></slot>
                    </el-main>
                </el-container>
            </el-container>
        </el-container>
        
    </div>
</template>

<script>
import Aside from './aside/aside';
export default {
    name: 'Container',
    components: {
        Aside, 
    },
    props: {
        aside: {
            type: String,
            default: ''
        },
        headerActiveIndex: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            vertical: 'vertical',
            horizontal: 'horizontal',
            user: {},
        }
    },
    mounted () {
        this.user = this.$store.getters.getuser;
        console.log(this.user)
    },
    methods: {
        logout() {
            this.$confirm('是否确定退出登录')
                .then(_=>{
                    this.$store.commit('setuser', '');
                    this.$store.commit('settoken', '');
                    this.$store.commit('setuid', '');
                    this.$store.commit('setuserType', '');
                    this.$store.commit('setpermission', '');
                    this.$store.commit('setuserName', '');
                    this.$store.commit('setsubType', '');
                    this.$store.commit('setgroupName', '');
                    this.$router.push({path: '/'});
                })
        }
    },
}
</script>

<style lang="scss" scoped>
.el-container.is-vertical.base-container{
    height: 100vh;
    max-height: 100vh;
    min-height: 100vh;
    overflow: auto;
}
.el-container.custom-container.content-container{
    height: 0;
}
.el-header{
    padding: 0;
}
.el-main{
    background: #f7f7f7;
    position: relative;
    &::-webkit-scrollbar{
        width:5px;
        height:10px;
        /**/
    }
    &::-webkit-scrollbar-track{
        background: #ebeef5;
        border-radius:2px;
    }
    &::-webkit-scrollbar-thumb{
        background: #c0c4cc;
        border-radius:10px;
    }
    &::-webkit-scrollbar-thumb:hover{
        background: #999;
    }
    &::-webkit-scrollbar-corner{
        background: #179a16;
    }
}
.el-aside{
    height: 100%;
    border-right: 1px solid #eee;
}
.header{
    background: #545c64;
    padding: 10px 20px;
    text-align: left;
    color: #fff;
    border-bottom: 1px solid #f7f7f7;
    box-sizing: border-box;
    .left{
        overflow: hidden;
        .img-box{
            width: 48px;
            height: 48px;
            float: left;
            margin-right: 10px;
            .img{
                max-width: 48px;
                max-height: 48px;
            }
        }
        .title{
            line-height: 50px;
            float: left;
        }
    }
    
    .right{
        text-align: right;
        line-height: 50px;
        .user{
            margin-right: 20px;
        }
        .logout{
            cursor: pointer;
            color: rgb(231, 235, 14);
        }
    }
}
</style>